import { CalendarOptions } from '@fullcalendar/core';
import { EventImpl } from '@fullcalendar/core/internal';
import { OrarioAttivita } from '../../form/select-field/select-field.component';

export interface CalendarView {
  type: 'timeGridWeek' | 'dayGridMonth' | 'timeGridDay' | 'threeDay';
  label: string;
}

export type CalendarMode = 'sanitario' | 'ambulatorio' | 'segnalazione';

export interface CalendarSlotPrefill {
  start: Date;
  end: Date;
}

export interface QuickAddMenuOption {
  action: string;
  icon: string;
  label: string;
}

export interface SlotQuickAddEvent extends CalendarSlotPrefill {
  action: string;
}

export interface ResourceSlotQuickAddEvent extends SlotQuickAddEvent {
  collaboratoreId: string | number;
}

export type ManageEventActionMode = 'pianificazione' | 'erogazione' | 'elimina';

export interface ManageEventAction {
  event: EventImpl;
  mode: ManageEventActionMode;
}

export interface CalendarEvent extends CustomEventStyleOptions {
  id?: string;
  dataInizioEvento?: Date | string;
  dataFineEvento?: Date | string;
  dataCreazioneEvento?: Date | string;
  titolo: string;
  descrizione: string;
  nomePaziente: string;
  stato?: CALENDAR_EVENT_STATE;
  tipoEvento?: {
    id: number;
    nome: string;
  };
  idSegnalazione?: number;
  idPaziente?: number;
  creatoDa?: string;
  idUtenteCreatore?: number;
  idSanitario?: number;
  editable?: boolean;
  idPrestazione?: string;

  idMacchinario?: number;
  nomePrestazione?: string;
  idStruttura?: number;
  idStrutturaFiglia?: string;
  eventoRipetuto?: boolean;
  avvisoAssenzaPaziente?: boolean;
  dataInizioErogazione?: Date | string | null;
  dataFineErogazione?: Date | string | null;
}

export interface CustomEventStyleOptions {
  backgroundColor?: string;
  borderColor?: string;
  textColor?: string;
}

export interface EventForm {
  type: string;
  dataInizio: Date;
  dataFine: Date;
  allDay: boolean;
  description: string;
  title: string;
  nomePaziente: string;
  indirizzo: string;
  stato: string;
}

export interface CustomCalendarOptions extends CalendarOptions {
  showTooltip?: boolean;
  changeViewButton?: boolean;
  addPrestazioneButton?: boolean;
  dateRangeSelection?: boolean;
  addNewEventButton?: boolean;
  nonClickableEventTypes?: number[];
}

export enum CALENDAR_EVENT_STATE {
  NON_SVOLTO = 'non svolto',
  SVOLTO_E_INVIATO_A_CASSA = 'svolto e inviato a cassa',
  NON_SVOLTO_E_INVIATO_A_CASSA = 'non svolto e inviato a cassa',
}

/**
 * Raw macchinario payload as returned by the backend, before mapping to `Item`.
 */
export interface MacchinarioDto {
  id: number | string;
  nome?: string;
  durataSlotMacchinario?: number;
  orariAttivita?: OrarioAttivita[];
}
